<template>
  <b-row>
    <!-- Not part of D2P rundown, disabled for now -->
    <!-- <b-col cols="12">
      <b-card class="mb-2">
        <pcc-dashboard />
      </b-card>
    </b-col> -->

    <b-col cols="12">
      <b-card style="overflow-x: hidden;">
        <pcc-table />
      </b-card>
    </b-col>

    <b-col cols="12">
      <b-card title="Request Product PCC">
        <rating-pcc-table />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BCardText,
} from 'bootstrap-vue'
import PccTable from '@/views/admin/pcc/PCCTable.vue'
import RatingPccTable from '@/views/admin/pcc/RatingPCCTable.vue'
// import PccDashboard from '@/views/admin/pcc/PccDashboard.vue'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BCardText,
    PccTable,
    RatingPccTable,
    // PccDashboard,
  },

  data() {
    return {
      isLoading: false,
      maplink: '',
    }
  },

  mounted() {
    //
  },

  methods: {
    //
  },
}
</script>
